<template>
  <div class="appointment-tabs">
    <button
      v-for="tab in tabs" :key="tab"
      @click="$emit('input', tab)"
      :class="{ 'selected-tab': tab === value }"
      class="appointment-tab">
      {{ tab }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    tabs: Array
  }
};
</script>

<style scoped>
.appointment-list-dialog .appointment-tabs {
  display: flex;
  width: 100%;
}
.appointment-list-dialog .appointment-tabs:before,
.appointment-list-dialog .appointment-tabs:after {
  content: '';
  width: 1rem;
  border-bottom: 1px solid rgb(224, 224, 224);
}
.appointment-list-dialog .appointment-tab {
  flex: auto;
  padding: 0.5rem 1rem;
  background-color: #fff;
  border-bottom: 1px solid rgb(224, 224, 224);
  outline: 0;
  font-size: 13px;
}
.appointment-list-dialog .appointment-tab:hover {
  background-color: rgb(250, 250, 250);
  border-radius: 4px 4px 0 0;
}
.appointment-list-dialog .selected-tab {
  background-color: rgb(245, 245, 245);
  border-bottom: 1px solid rgb(134, 134, 134);
  border-radius: 4px 4px 0 0;
}
</style>